<template>
  <div id="app">
      <keep-alive :include="['zhiBoList','factoryList','classify','HomeSec', 'activityTheme','searchList']">
      <router-view class="Router"></router-view>
    </keep-alive>
<!--    <router-view class="Router" v-if="!$route.meta.keepAlive"></router-view>-->
<!--    <tabBar v-if="($route.path==='/cart'||$route.path==='/' || $route.path==='/service' || $route.path==='/user')"/>-->
    <tabBar v-if="($route.path==='/cart'||$route.path==='/' || $route.path==='/service' || $route.path==='/user' || $route.path==='/order' || $route.path==='/goodList' || $route.path==='/goodClassify'|| $route.path==='/zhiBoList'|| $route.path==='/materialList' || $route.path==='/factoryList')&&tabbarShow"></tabBar>
  </div>

</template>

<script>
// 全局守卫
import store from "./store";
import router from './router'
import { GetParam } from "@/utils/getParam.js";
import {getLogin } from '@/api/info'
import VConsole from 'vconsole'
import tabBar from './components/tabBar'
import { systemConfig } from '@/api/info'
// router.beforeEach((to, from, next) =>{
//   // alert("还没有登录,请先登录!");
//   // 微信授权登录
//   var token = store.state.token;
//   // let redirect_uri = encodeURIComponent('http://jpzs-zst.itos.cn/')
//   let appid = 'wxe86e357621c76520'
//   let baseUrl= ''
//   if (process.env.VUE_APP_MODE === 'development') {
//     // 开发环境下的执行操作
//     baseUrl = 'http://localhost.itos.cn'
//     // console.log('kaifa')
//   } else {
//     // 生产环境下的执行操作
//     baseUrl = 'http://jpzs-zst.itos.cn'
//   }
//   let redirect_uri = encodeURIComponent( // 本地 http://localhost.itos.cn/  // 线上 http://jpzs-zst.itos.cn
//     baseUrl + to.fullPath
//   );
//   console.log(to.path);
//   if (!token) {
//     //let oAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WX_APPID}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
//     let url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid +"&redirect_uri=" + redirect_uri +"&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
//     console.log("window.location.href", window.location.href);
//     let code = GetParam(window.location.href.split("#")[0], "code");
//     // console.log(code)
//     if (!code) {
//       window.location.href = url;
//     } else {
//       console.log('you code')
//       code = code // GetParam(window.location.href, "code");
//       console.log(code)
//       let data = {
//         code:code,
//         source: 'ZHQQ'
//       };
//       // 下面是我根据我实际业务场景编写的，主要是根据code获取个人信息保存。授权登录走到这一步基本就做完了
//       getLogin(data).then(res => {
//         console.log(res)
//         if (res.code == 200){
//           store.commit("setToken", res.data.token); // 保存token
//           // localStorage.setItem('token',res.data.token)
//           store.commit('setTabbarShow',true);
//           console.log('登录成功')
//           next();
//         } else if (res.code==401){
//           console.log(401)
//         }else {
//           window.location.href = url // 如果请求失败继续走重定向去获取code这一步
//         }
//       })
//
//     }
//   } else {
//     next();
//   }
// })
export default {
  components: {
    tabBar
  },
  data(){
    return{
      login: 1  // 0显示登陆 1隐藏
    }
  },
  created() {
    if(this.$store.state.vConsoleShow === true) {
      new VConsole()
    }
    this.getSystemConfig()
    // 微信授权登录
    // var that = this
    // var token = this.$store.state.token
    // if (token == ''){
    //   this.wxCode = this.getQueryString('code')
    //   var code = this.getQueryString('code')
    //   console.log('zheli sss')
    //   if (code !='' && code !=null && this.login==1) {
    //     // that.getLogin()
    //     console.log('这里有code 请求接口')
    //     this.getLogin()
    //   } else { // code 为空
    //     that.$store.commit('setTabbarShow',false);
    //     console.log('code 为空 要获取code 要登录登录')
    //     console.log(this.$store.state.tabbarFalg)
    //     if(token==''){
    //       that.login=0; // 显示登录
    //       that.$store.commit('setTabbarShow',false);
    //       this.toGetWXCode() // 获取code
    //     } else {
    //       that.login=1; // 隐藏登录
    //       that.$store.commit('setTabbarShow',true);
    //     }
    //   }
    //
    // }else {
    //
    // }
  },
  // 监听,当路由发生变化的时候执行
  watch:{
    $route(to,from){
      //判断是否显示tabbar
      if (this.$store.state.token == ''){
        // console.log('token null')
        this.$store.commit('setTabbarShow',false);
      } else {
        // console.log(999)
        this.$store.commit('setTabbarShow',true);
      }
    }
  },
  computed: {
    tabbarShow(){
      return this.$store.state.tabbarFalg
    }
  },
  methods: {
    getSystemConfig(){ // 获取主题色
      systemConfig().then(res=>{
        if (res.code == 200){
          // console.log(res)
          this.$store.commit("setAppTheme", res.data.theme);
        }
      })
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);  //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null)
        context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined" ? "" : context;
    },
    toGetWXCode() {
      var that = this
      const ua = navigator.userAgent.toLowerCase();
      const isWechat = ua.match(/micromessenger/i) === 'micromessenger';
      if (!isWechat) {
        // 网页环境不触发微信OAuth
        this.$store.commit('setTabbarShow', true);
        return;
      }
      // let appid = 'wxe86e357621c76520'
      let baseUrl= ''
      // if (process.env.VUE_APP_MODE === 'development') {
      //   // 开发环境下的执行操作
      //   baseUrl = 'http://localhost.itos.cn'
      //   // console.log('kaifa')
      // } else {
      //   // 生产环境下的执行操作
      //   baseUrl = 'http://jpzs-zst.itos.cn'
      // }
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url
      let redirect_uri = encodeURIComponent( // 本地 http://localhost.itos.cn/  // 线上 http://jpzs-zst.itos.cn
        baseUrl
      );
      let redirectUrl = redirect_uri
      let WX_APPID = 'wxe86e357621c76520'
      let oAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WX_APPID}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      var code = this.getQueryString('code')
      console.log('code3',code)
      if (code != '' || code != null) {
        that.login = 0;
        // console.log('login5', this.login)
        window.location.href = oAuthUrl
        this.login = 0;
      }
    },
    async getLogin(){ // 授权登录 Login
      var that  = this;
      var data = {
        code: this.wxCode,
        source: 'ZHQQ'
      }
      var res = await that.$Http.login(data)
      if (res.code == 200){
        this.$store.commit("setToken", res.data.token); // 保存token
        // localStorage.setItem('token',res.data.token)
        that.$store.commit('setTabbarShow',true);
        console.log('登录成功')
        that.login= 1; // 隐藏登录

      } else{
        console.log('要登录')
        this.$toast(res.message)
        that.login=0
        that.$store.commit('setTabbarShow',false);
        this.$store.commit("setToken", ''); // 清除key
      }

    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #282828;font-size: 28px;
}
body{
  background: #f5f5f3;
}
.null-box{
  height: 120px;
}
/* 文本溢出隐藏 */
.uni-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.justify-align {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left-justifying {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.content-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
